import { gsap } from "gsap";
import DefaultBlock from "/scripts/default/block";
import { Draggable, InertiaPlugin } from "gsap/all";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(InertiaPlugin, Draggable);

export default class UIDraggable extends DefaultBlock {
	init() {
		// Define Variables
		this.DOM = {
			svg: this.block.querySelector(".ui-draggable__flair"),
			container: this.block.querySelector(".ui-draggable__grid-wrapper"),
			containerItem: this.block.querySelector(".ui-draggable__grid-item"),
		};

		// Call draggable animation & window resize function
		this.initCreateDraggable();
	}

	createDraggable() {
		// Define width and height values of each grid / container item
		const valueX = this.DOM.containerItem.getBoundingClientRect().width;
		const valueY = this.DOM.containerItem.getBoundingClientRect().height;

		// Set the autoAlpha of current block to 1
		gsap.set(this.block, { autoAlpha: 1 });

		// Call the watchPreferedMotion function to only trigger animation
		// if user does not have reduced animation enabled
		watchPreferredMotion(() => {
			// Create draggable
			Draggable.create(this.DOM.svg, {
				type: "x,y",
				bounds: this.DOM.container,
				// Enable inertia to allow deceleration when the user
				// flicks or drags the item
				inertia: true,
				// Use snap to force the draggable item to stop within
				// an increment of the valueX and valueY constances
				// defined above - allowing it to snap to the grid!
				snap: {
					x: function (value) {
						return Math.round(value / valueX) * valueX;
					},
					y: function (value) {
						return Math.round(value / valueY) * valueY;
					},
				},
			});
		});
	}

	initCreateDraggable() {
		this.createDraggable();
		window.addEventListener("resize", this.createDraggable.bind(this));
	}
}
